/**
 * 通用 Excel 导入弹层（对齐商业版：下载模板 → 上传文件 → 开始导入）
 * 支持逐行错误报告：后端返回 {addCount, failCount, failures:[{row,reason}]} 时弹出「导入结果」明细。
 *
 * 用法：
 *   <import-modal v-model="showImport" title="无票收入导入"
 *                 templateUrl="/api/invoice-non-income/template"
 *                 :import-fn="importNonIncome" @success="loadList"/>
 *
 * importFn 约定：接收 FormData，返回 Promise（resolve 后端 JsonResult）
 */
<template>
    <div>
        <Modal v-model="opened">
            <div slot="header">{{ title }}</div>
            <div class="padding">
                <div>第一步：请点击下面的链接下载 Excel 导入模板，并按照模板填写信息</div>
                <div class="margin-top">
                    <a class="text-hover" style="color:#3b91ff;cursor:pointer" @click="downloadTemplate">下载模板</a>
                </div>
                <div class="margin-top">第二步：导入填写好的 Excel 文件</div>
                <div class="margin-top">
                    <input type="file" ref="importFile" accept=".xlsx,.xls">
                </div>
                <div v-if="error" style="color:#e64c4c" class="margin-top">{{ error }}</div>
            </div>
            <div class="text-center margin-top">
                <Button color="primary" @click="submitImport" :loading="loading">开始导入</Button>
                <Button @click="opened=false">取消</Button>
            </div>
        </Modal>
        <Modal v-model="showResult" :width="560" :middle="true" :hasCloseIcon="true">
            <div slot="header">导入结果</div>
            <div class="padding">
                <p>成功导入 <b>{{ resultAdd }}</b> 条，失败 <b style="color:#e64c4c">{{ resultFail }}</b> 条。</p>
                <Table v-if="resultRows.length" :datas="resultRows" :border="true" :stripe="true" class="margin-top">
                    <TableItem title="行号" prop="row" :width="80"/>
                    <TableItem title="失败原因" prop="reason"/>
                </Table>
                <p v-else class="margin-top">所有数据均已成功导入。</p>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    name: 'ImportModal',
    props: {
        value: { type: Boolean, default: false },
        title: { type: String, default: '导入' },
        templateUrl: { type: String, required: true },
        importFn: { type: Function, required: true }
    },
    data() {
        return { loading: false, error: '', showResult: false, resultAdd: 0, resultFail: 0, resultRows: [] };
    },
    computed: {
        opened: {
            get() { return this.value; },
            set(v) { this.$emit('input', v); }
        }
    },
    methods: {
        downloadTemplate() {
            window.open(this.templateUrl);
        },
        submitImport() {
            const input = this.$refs.importFile;
            if (!input.files || !input.files.length) {
                this.error = '请先选择需要导入的文件';
                return;
            }
            const fd = new FormData();
            fd.append('file', input.files[0]);
            this.loading = true;
            this.error = '';
            this.importFn(fd).then((res) => {
                this.loading = false;
                const data = (res && res.data) || {};
                const failures = (data && data.failures) || [];
                input.value = '';
                if (failures.length) {
                    this.opened = false;
                    this.resultAdd = data.addCount || 0;
                    this.resultFail = data.failCount || failures.length;
                    this.resultRows = failures;
                    this.showResult = true;
                    this.$emit('success');
                } else {
                    this.opened = false;
                    this.$Message.success((res && res.msg) || '导入成功');
                    this.$emit('success');
                }
            }).catch(err => {
                this.loading = false;
                this.error = (err && err.msg) || '导入失败，请检查模板格式';
            });
        }
    }
};
</script>
